import moment from 'moment';
import { Breakpoints, Colors } from '../../shared/styles/StyleConst';
import i18n from '../../R/string/i18n';
import { setToStartOfDay } from '../../shared/utils/date';

const CalendarInfo = ({
  datePickerLabels,
  displayFormat,
  uiStartDate,
  uiEndDate,
  onClose,
  isMobileWidth,
  withoutPrice,
}: {
  datePickerLabels?: {
    startDate: string;
    endDate: string;
  };
  displayFormat: string;
  uiStartDate: moment.Moment | Null;
  uiEndDate: moment.Moment | Null;
  onClose: (uiStartDate: moment.Moment | Null, uiEndDate: moment.Moment | Null) => void;
  isMobileWidth: boolean;
  withoutPrice?: boolean;
}) => {
  const startDateText = uiStartDate ? uiStartDate.format(displayFormat) : '';
  const endDateText = uiEndDate ? uiEndDate.format(displayFormat) : '';
  const isCompleteInput = uiStartDate && uiEndDate;
  const nights =
    uiStartDate && uiEndDate
      ? setToStartOfDay(uiEndDate).diff(setToStartOfDay(uiStartDate), 'days')
      : null;

  return (
    <>
      <div className="calendar-info">
        <div className="date-info text-center">
          {!uiStartDate && !uiEndDate && (
            <p className="date-range-text">
              {datePickerLabels?.startDate || i18n.webYadoChooseCheckinDate()}
            </p>
          )}
          {uiStartDate && !uiEndDate && (
            <p className="date-range-text">
              {datePickerLabels?.endDate || i18n.webYadoChooseCheckoutDate()}
            </p>
          )}
          {isCompleteInput && nights && (
            <p className="date-range-text">
              {i18n.webYadoNightsFromCheckinToCheckout({
                checkinDate: startDateText,
                checkoutDate: endDateText,
                number: nights,
              })}
            </p>
          )}
          {withoutPrice ? null : (
            <>
              <p className="mb-0 calendar-info-alert">{i18n.calendarInfoAlert()}</p>
              <p className="mb-0 mb-sm-4 caption">
                {i18n.webYadoLocalPriceShownBasedOnCurrentExchange()}
              </p>
            </>
          )}
        </div>
        {isMobileWidth && (
          <button
            type="button"
            disabled={!isCompleteInput}
            onClick={() => onClose(uiStartDate, uiEndDate)}
          >
            {i18n.webYadoButtonDone()}
          </button>
        )}
      </div>
      <style jsx>{`
        @media screen and (min-width: ${Breakpoints.smMin}) {
          .calendar-info {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            border-top: 1px solid #e8e8e8;
            padding-top: 10px;
            margin: 0 22px;
          }
          .calendar-info::before {
            content: '';
            background: #eeeeee;
            height: 1px;
            width: 94%;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
          .date-info p {
            margin-bottom: 12px;
            font-size: 14px;
            letter-spacing: 1.03px;
            color: #333333;
          }
        }
        @media screen and (max-width: ${Breakpoints.xsMax}) {
          .calendar-info {
            position: absolute;
            bottom: ${withoutPrice ? -40 : -135}px;
            z-index: 3;
            background: #fff;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
          }
          .date-info p {
            margin-bottom: 0;
            font-size: 13px;
            letter-spacing: 0.89px;
            color: ${Colors.textDarkGray};
          }
          .calendar-info button {
            width: calc(100% - ${withoutPrice ? 36 : 56}px);
            height: 47px;
            border: none;
            color: ${Colors.onsenWhite};
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 2.03px;
            background-color: ${Colors.pjtBlue};
            margin-top: 15px;
          }
          .calendar-info button:disabled,
          button[disabled] {
            background-color: ${Colors.gray600};
          }
          .date-info {
            width: 100vw;
          }
          .date-range-text {
            font-size: 15px !important;
          }
        }
        .calendar-info-alert {
          color: ${Colors.red} !important;
        }
      `}</style>
    </>
  );
};

export default CalendarInfo;
